export const environment = {
  production: true,
  apiUrl: "https://faithhub.site/api_umyocards/public/api/"
};


